/* Peptides+ product page sections (pp-*).
 * Every feature is scoped to its own section root, so sections can be
 * re-ordered, duplicated or re-rendered in the theme editor.
 * Add to cart is NOT handled here: the theme's <product-form> element
 * (assets/global.js) submits the form and opens the cart drawer. */
(function () {
  'use strict';
  if (window.__ppPdpLoaded) return; window.__ppPdpLoaded = true;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* hide broken images, as the design does */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.pp') && !t.hasAttribute('onerror')) t.style.visibility = 'hidden';
  }, true);

  /* ───────── main product ───────── */
  function initMain(root) {
    if (root.__ppInit) return; root.__ppInit = true;

    /* gallery */
    var slides = $$(root, '.slide'), th = $$(root, '.thumbs button'), gi = 0;
    function setG(n) {
      if (!slides.length) return;
      gi = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('on', i === gi); });
      th.forEach(function (t, i) { t.setAttribute('aria-selected', i === gi ? 'true' : 'false'); });
      var tb = th[gi], box = tb && tb.parentNode;
      if (box && box.scrollTo) box.scrollTo({ left: tb.offsetLeft - box.clientWidth / 2 + tb.clientWidth / 2, behavior: RM ? 'auto' : 'smooth' });
    }
    th.forEach(function (t, i) { t.addEventListener('click', function () { setG(i); }); });
    $$(root, '[data-g]').forEach(function (b) { b.addEventListener('click', function () { setG(gi + +b.dataset.g); }); });

    /* bundles */
    var opts = $$(root, '.pk');
    var idInput = root.querySelector('[data-pp-id]');
    var qtyInput = root.querySelector('[data-pp-qty]');
    var atc = root.querySelector('[data-pp-atc]');
    var stk = root.querySelector('[data-pp-stk]');
    var stkSub = root.querySelector('[data-pp-stk-sub]');
    var stkBtn = root.querySelector('[data-pp-stk-btn]');
    var stkLabel = stkBtn ? stkBtn.textContent.trim() : '';

    function select(i, user) {
      var o = opts[i]; if (!o) return;
      var d = o.dataset, radio = o.querySelector('input');
      if (radio) radio.checked = true;
      var available = d.available === 'true';
      if (idInput) idInput.value = d.variant;
      if (qtyInput) qtyInput.value = d.qty || 1;
      if (atc) {
        atc.disabled = !available;
        atc.textContent = available ? (atc.dataset.label + ' · ' + d.price) : atc.dataset.soldout;
      }
      if (stkSub) {
        stkSub.innerHTML = '';
        stkSub.appendChild(document.createTextNode(d.name));
        var pr = document.createElement('b'); pr.className = 'stk-pr'; pr.textContent = ' · ' + d.price; stkSub.appendChild(pr);
        var dd = document.createElement('span'); dd.className = 'stk-d'; dd.textContent = ' · ' + d.pots + ' ' + d.potword + ' · ' + d.days + ' dagen'; stkSub.appendChild(dd);
      }
      if (stkBtn) {
        stkBtn.disabled = !available;
        stkBtn.innerHTML = '';
        var bp = document.createElement('span'); bp.className = 'stk-bp'; bp.textContent = d.price + ' · ';
        stkBtn.appendChild(bp); stkBtn.appendChild(document.createTextNode(stkLabel));
      }
      if (user && d.slide !== undefined && +d.slide >= 0) setG(+d.slide);
    }
    opts.forEach(function (o, i) {
      var r = o.querySelector('input');
      if (r) r.addEventListener('change', function () { select(i, true); });
    });
    var start = 0;
    opts.forEach(function (o, i) { var r = o.querySelector('input'); if (r && r.checked) start = i; });
    select(start, false);

    /* delivery estimate: N days out, skipping Sunday */
    var eta = root.querySelector('[data-pp-eta]');
    if (eta) {
      var dt = new Date(); dt.setDate(dt.getDate() + (parseInt(root.dataset.etaDays, 10) || 2));
      if (dt.getDay() === 0) dt.setDate(dt.getDate() + 1);
      try { eta.textContent = dt.toLocaleDateString(root.dataset.locale || 'nl', { day: 'numeric', month: 'long' }); } catch (e) {}
    }

    /* sticky bar once the buy button leaves the screen */
    if (stk && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        stk.classList.toggle('on', show); stk.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stkBtn) stkBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
    /* mirror the theme's loading state on the sticky button */
    if (stkBtn && atc && 'MutationObserver' in window) {
      new MutationObserver(function () { stkBtn.classList.toggle('loading', atc.classList.contains('loading')); })
        .observe(atc, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ───────── ingredients ───────── */
  function initIng(root) {
    if (root.__ppInit) return; root.__ppInit = true;
    var box = root.querySelector('[data-pp-rows]'), tabs = $$(root, '.ing2-tabs button');
    if (box) {
      var rows = $$(box, '[data-ing-row]');
      var show = function (k) {
        tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === k ? 'true' : 'false'); });
        /* only the active tab's rows stay in the DOM, so :last-child / :nth-child match the design */
        rows.forEach(function (r) { if (r.parentNode) r.parentNode.removeChild(r); });
        rows.forEach(function (r) { if (+r.dataset.tab === k) { r.removeAttribute('hidden'); box.appendChild(r); } });
        box.classList.remove('fade'); void box.offsetWidth; box.classList.add('fade');
      };
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      show(0);
    }
    var jl = root.querySelector('[data-pp-jar]');
    if (jl) {
      if ('IntersectionObserver' in window && !RM) {
        new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { jl.classList.add('in'); o.disconnect(); } }); }, { threshold: .25 }).observe(jl);
      } else jl.classList.add('in');
    }
  }

  /* ───────── reviews slider ───────── */
  function initReviews(root) {
    if (root.__ppInit) return; root.__ppInit = true;
    var tr = root.querySelector('[data-pp-track]'), dots = root.querySelector('[data-pp-dots]');
    var prev = root.querySelector('[data-rv="-1"]'), next = root.querySelector('[data-rv="1"]');
    if (!tr || !dots || !prev || !next) return;
    var cards = tr.children, pages = 1, step = 1;
    function idx() { return Math.min(pages - 1, Math.round(tr.scrollLeft / step)); }
    function go(i) { tr.scrollTo({ left: Math.max(0, Math.min(pages - 1, i)) * step, behavior: RM ? 'auto' : 'smooth' }); }
    function sync() {
      var i = idx(), max = tr.scrollWidth - tr.clientWidth - 2;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      prev.disabled = tr.scrollLeft <= 2; next.disabled = tr.scrollLeft >= max;
    }
    function measure() {
      if (!cards.length) return;
      var gap = parseFloat(getComputedStyle(tr).columnGap) || 0;
      step = cards[0].getBoundingClientRect().width + gap || 1;
      var per = Math.max(1, Math.floor((tr.clientWidth + gap + 1) / step));
      pages = Math.max(1, cards.length - per + 1);
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button'); d.type = 'button';
        d.setAttribute('aria-label', 'Ga naar review ' + (i + 1)); d.dataset.i = i;
        d.addEventListener('click', function () { go(+this.dataset.i); });
        dots.appendChild(d);
      }
      dots.hidden = pages < 2; prev.hidden = next.hidden = pages < 2;
      sync();
    }
    prev.addEventListener('click', function () { go(idx() - 1); });
    next.addEventListener('click', function () { go(idx() + 1); });
    tr.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });
    var t; tr.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(sync); }, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
    measure();
  }

  /* ───────── FAQ: one open at a time ───────── */
  function initFaq(root) {
    if (root.__ppInit) return; root.__ppInit = true;
    var ds = $$(root, '.faq details');
    ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
  }

  var MAP = { '[data-pp-main]': initMain, '[data-pp-ing]': initIng, '[data-pp-reviews]': initReviews, '[data-pp-faq]': initFaq };
  function initAll(scope) {
    Object.keys(MAP).forEach(function (sel) {
      $$(scope || document, sel).forEach(function (el) { MAP[sel](el); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var pk = e.target.closest && e.target.closest('.pk');
    if (pk) { var r = pk.querySelector('input'); if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change')); } }
  });
})();
